<template>
  <div :class="type ? `spinner spinner-${type}` : 'spinner spinner-inline'">
    <div>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'lp-spinner',
  props: { type: { type: String, default: 'inline' } },
})
</script>
